"use client";

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";
import styles from "./AcrCyberProtection.module.css";

interface ItemType {
  icon: StaticImageData;
  title: string;
  desc: string;
  link?: string; // OPTIONAL LINK
}

interface Props {
  title?: string;
  subtitle?: string;
  items: ItemType[];
}

const AcrCyberProtection: React.FC<Props> = ({
  title = "Cyber Protection",
  subtitle = "Stay secure, productive, and resilient with smart, integrated cyber-protection tools designed to prevent downtime and data loss.",
  items,
}) => {
  return (
    <div className={styles.wrapper}>
      <Container>
        {/* Heading */}
        <div className={styles.headingBox}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtext}>{subtitle}</p>
        </div>

        {/* Feature Cards */}
        <Row className="gy-4">
          {items.map((item, index) => {
            const CardContent = (
              <div className={`${styles.card} align-items-center`}>
                <div className={styles.iconBox}>
                  <Image src={item.icon} width={26} height={26} alt={item.title} />
                </div>

                <div className={styles.textCol}>
                  <h4 className={styles.cardTitle}>{item.title}</h4>
                  <p className={styles.cardDesc}>{item.desc}</p>
                </div>
              </div>
            );

            return (
              <Col key={index} md={6}>
                {/* If link exists → wrap in Next.js Link */}
                {item.link ? (
                  <Link
                    href={item.link}
                    className="text-decoration-none"
                    style={{ color: "inherit" }}
                  >
                    {CardContent}
                  </Link>
                ) : (
                  CardContent
                )}
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};

export default AcrCyberProtection;
